import { EngagementDetailsActions } from "./EngagementDetailsAction";

const initialState = {
  engagementDetails: "",
  error: "",
};

const engagementDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case EngagementDetailsActions.GET_ENGAGEMENT_DETAIL_SUCCESS:
      return {
        ...state,
        engagementDetails: action.payload,
      };
    case EngagementDetailsActions.GET_ENGAGEMENT_DETAIL_ERROR:
      return {
        ...state,
        error: action.payload,
        engagementDetails: "",
      };
    default:
      return state;
  }
};

export default engagementDetailsReducer;
